import { createStore, applyMiddleware, compose } from 'redux'
import { routerMiddleware } from 'connected-react-router'
import { createHashHistory } from 'history'
import thunk from 'redux-thunk'
import * as Sentry from '@sentry/browser'
import createSentryMiddleware from 'redux-sentry-middleware'

import rootReducer from './reducers'
import { setLocale } from './actions'

declare global {
	interface Window {
		__REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: Function
		__REDUX_DEVTOOLS_EXTENSION__?: Function
	}
}

if (process.env.NODE_ENV === 'production') {
	Sentry.init({
		dsn: process.env.REACT_APP_SENTRY_DSN,
		debug: false,
		environment: process.env.NODE_ENV,
		blacklistUrls: [
			/facebook/,
			/gtm/,
			/^chrome:\/\//i,
			/extensions\//i,
			/widgetapi/,
			/doubleclick/,
		],
	})
}

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

export const history = createHashHistory()

export const store = createStore(
	rootReducer(history),
	composeEnhancers(applyMiddleware(
		thunk,
		routerMiddleware(history),
		createSentryMiddleware(Sentry),
	)),
)

// try to autodetect locale
store.dispatch(setLocale())
